// @flow

import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { Node } from 'react'

import Button from '../Button'
import Toolbox from '../Toolbox'
import ActivityPriorityTable from './ActivityPriorityTable'
import ConfigItemModal from '../ConfigItem/ConfigItemModal'

import {
  createActivityPriority,
  getActivityPriorities,
} from '../../core/api/api.pipeline'

const ActivityPriority = (): Node => {
  const { t } = useTranslation('Activities')

  const [isModalOpen, setModalOpen] = useState(false)

  const handleClose = () => setModalOpen(false)
  const handleCreate = () => setModalOpen(true)

  return (
    <>
      <Toolbox>
        <div className='toolbox__cell'>
          <Button.Save onClick={handleCreate}>
            {t('AddPriorityButton')}
          </Button.Save>
        </div>
      </Toolbox>
      <ActivityPriorityTable onEdit={handleCreate} />
      {isModalOpen && (
        <ConfigItemModal
          addListItemPlaceholder={t('NewPrioritiesPlaceholder')}
          addListItemTitle={t('AddNewPriority')}
          createApi={createActivityPriority}
          listApi={getActivityPriorities}
          listTitle={t('ActivityPriorityList')}
          modalTitle={t('CreateActivityPriorityTitle')}
          onClose={handleClose}
        />
      )}
    </>
  )
}

export default ActivityPriority
